export const agenciesKeys = {
  all: ['agencies'] as const,
};
